
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { BarChart3 } from "lucide-react";
import { KPITiles } from "./KPITiles";
import { GBPReviewTiles } from "./GBPReviewTiles";
import { TodayVisits } from "./TodayVisits";
import { PendingTasks } from "./PendingTasks";
import { ReferralAhaCard } from "@/components/referral/ReferralAhaCard";
import { MobilePageWrapper } from "@/components/layout/MobilePageWrapper";
import { useTenantConfig } from "@/hooks/useTenantConfig";

export const Dashboard: React.FC = () => {
  const { t } = useTranslation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { hasCalendar } = useTenantConfig();

  return (
    <MobilePageWrapper
      title={t("dashboard")}
      sidebarOpen={sidebarOpen}
      onSidebarOpenChange={setSidebarOpen}
    >
      <div className="space-y-8 p-4 md:p-6">
        {/* Contextual referral prompt — renders only at an "aha" moment
            (new review this week), dismissible + throttled. */}
        <ReferralAhaCard />

        {/* One section heading spanning both tile rows (general KPIs + Google
            profile stats), per the page-level section pattern. */}
        <section className="space-y-3">
          <div className="flex items-center gap-2 px-1">
            <BarChart3 className="h-5 w-5 text-primary" />
            <h2 className="text-lg font-medium tracking-tight text-foreground-strong">
              {t("statsOverview")}
            </h2>
          </div>
          <div className="space-y-4">
            <KPITiles />
            <GBPReviewTiles />
          </div>
        </section>

        {hasCalendar && <TodayVisits />}

        <PendingTasks />
      </div>
    </MobilePageWrapper>
  );
};
